import { useState } from "react";
import { HeritierType} from "../../static/types/commonTypes/individualType";
import { heritierIndividualState} from "../../static/initialState/commonInitialState/individualInitialState";
import Heritier from "./Heritier";

type HeritierListProps = {
    checkedHeritier: boolean;
    heritier: HeritierType[];
    addButtonText: string;
    removeButtonText: string;
    labelItem?: string;
    setHeritier: (individuals: HeritierType[]) => void;
    setHeritierValidity: (isValid: boolean) => void;
};

export default function HeritierList({
    checkedHeritier,
    heritier,
    addButtonText,
    removeButtonText,
    labelItem,
    setHeritier,
    setHeritierValidity,
}: HeritierListProps) {
    const [listValidity, setListValidity] = useState<boolean[]>(
        heritier.map(() => false)
    );

    const addIndividual = () => {
        setHeritier([...heritier, heritierIndividualState]);
        setListValidity([...listValidity, false]);
    };

    const removeLastIndividual = () => {
        if (heritier.length > 1) {
            setHeritier(heritier.slice(0, -1));
            setListValidity(listValidity.slice(0, -1));
        }
    };

    const updateIndividual = (index: number, updatedIndividual: HeritierType) => {
        const newIndividuals = [...heritier];
        newIndividuals[index] = updatedIndividual;
        setHeritier(newIndividuals);
    };

    const updateIndividualsValidity = (index: number, isValid: boolean) => {
        const newValidity = [...listValidity];
        newValidity[index] = isValid;
        setListValidity(newValidity);
        setHeritierValidity(newValidity.every((valid) => valid));
    };

    return (
        <>
            <div className="mb-3 row">
                {heritier.map((heritier, index) => (
                    <div key={index} className="tab-content mb-2">
                        <div className="mb-3 row pt-3">
                            <div className="mb-3 row">
                                <div className="col-sm-10">
                                    {labelItem ? (
                                        <h6 className="text-bold">{`${labelItem} ${index + 1}`}</h6>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                        <Heritier
                            checkedHeritier={checkedHeritier}
                            heritier={heritier}
                            changeHeritier={(details) => {
                                const updatedIndividual: HeritierType = {
                                    ...heritier,
                                    ...details,
                                };
                                updateIndividual(index, updatedIndividual);
                            }}
                            qualitiesOptions={[
                                "",
                                "Héritier légal",
                                "Héritier légataire à titre universel",
                                "Héritier légataire à titre particulier",
                                "Héritier en vertu d'un testament olographe",
                                "Héritier en vertu d'un testament mystique",
                                "Héritier en vertu d'un testament authentique",
                                "autre"
                            ]}
                            onValidationChange={(isValid: boolean) =>
                                updateIndividualsValidity(index, isValid)
                            }
                        />
                    </div>
                ))}
            </div>

            <div className="row mb-3">
                <div className="col d-flex justify-content-center align-items-center gap-5">
                    <button type="button" onClick={addIndividual}>
                        {addButtonText}
                    </button>
                    {heritier.length > 1 && (
                        <button type="button" onClick={removeLastIndividual}>
                            {removeButtonText}
                        </button>
                    )}
                </div>
            </div>
        </>
    );
}